import React from 'react';
import './SpinRedeemDialog.css';
import redeemSpinIcon from '../../images/v1/rewards/ic_redeem_spin.png'
import { useTranslation } from 'react-i18next';
const SpinRedeemDialog = ({ spinAmount, timeRemaining, onClose, onRedeem }) => {

    const { t } = useTranslation();

    return (
        <div className="spin-redeem-overlay">
            <div className="spin-redeem-dialog">
                <button className="close-button" onClick={onClose}>X</button>
                <div className="dialog-content">
                    <img src={redeemSpinIcon} alt="Redeem Spin" className="redeem-icon" />
                    <h2 className="spin-amount-msg">{t('spend_coins_to_play', { spinAmount: spinAmount })}</h2>
                    <p className="reward-text">
                        {t('play_free_or_spend_coins', { timeRemaining: timeRemaining })}
                    </p>
                    <button className="redeem-button" onClick={onRedeem}>
                        {t('play_again')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SpinRedeemDialog;